import { BsFacebook, BsInstagram, BsTwitter } from "react-icons/bs";
import { FaSoundcloud } from "react-icons/fa";

const photos = [
  {
    src: "/full-camp-photo.jpeg",
    alt: "The whole camp together in the pavilion",
    className: "is-feature",
  },
  {
    src: "/another-happy-camper.jpeg",
    alt: "Two campers smiling in the dining hall",
  },
  { src: "/idk.jpeg", alt: "Counselors and campers sharing a meal" },
  {
    src: "/gatka.jpeg",
    alt: "Campers in bana with gatka sticks before the evening show",
    className: "is-wide",
  },
  { src: "/icebreakers.jpeg", alt: "Campers playing icebreakers outside" },
  {
    src: "/gathered-campers.jpeg",
    alt: "Campers gathered under the pines on a cold morning",
  },
  { src: "/happy-campers.jpeg", alt: "Two campers at lunch" },
  {
    src: "/counselor-hot-sauce.jpeg",
    alt: "Counselors at the dining table",
  },
];

const mediaTypes = [
  {
    name: "Instagram",
    icon: <BsInstagram aria-hidden="true" />,
    link: "https://www.instagram.com/houstonsikhyouthcamp/?hl=en",
  },
  {
    name: "Facebook",
    icon: <BsFacebook aria-hidden="true" />,
    link: "https://www.facebook.com/p/Houston-Sikh-Youth-Camp-100064290505314/",
  },
  {
    name: "SoundCloud",
    icon: <FaSoundcloud aria-hidden="true" />,
    link: "https://soundcloud.com/houston-sikh-youth-camp",
  },
  {
    name: "Twitter",
    icon: <BsTwitter aria-hidden="true" />,
    link: "https://twitter.com/houstonsikhcamp",
  },
];

export default function MediaSection() {
  return (
    <section className="hsyc-section" id="media">
      <div className="hsyc-wrap">
        <h2>Photos from camp</h2>
        <div className="hsyc-photos">
          {photos.map((photo) => (
            <img
              key={photo.src}
              src={photo.src}
              alt={photo.alt}
              className={photo.className}
              loading="lazy"
            />
          ))}
        </div>
        <ul className="hsyc-social">
          {mediaTypes.map((media) => (
            <li key={media.name}>
              <a href={media.link} target="_blank" rel="noreferrer">
                {media.icon}
                {media.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
